  <template>
  <v-layout>
    <div>
      <v-select
        v-model="selectedColumn"
        :items="columns"
        item-text="text"
        item-value="value"
        class="px-1"
        v-on:change="emitSearch"
      ></v-select>
    </div>
    <div>
      <v-text-field
        v-model="searchText"
        :label="$t('searchBar.search')"
        v-on:keyup="emitSearch"
      ></v-text-field>
    </div>
    <!-- <v-flex>
      <v-layout fill-height align-center>
        <v-btn class="secondary search-button" @click="emitSearch"><img class="search-icon" :src="require('@/assets/icons/msyst-icon_search-white.svg')" contain></v-btn>
      </v-layout>
    </v-flex> -->
  </v-layout>
</template>

<script>
export default {
  props: ['columns'],
  data () {
    return {
      selectedColumn: this.columns[0].value,
      searchText: ''
    }
  },
  methods: {
    emitSearch () {
      this.$emit('search', {selectedColumn: this.selectedColumn, searchText: this.searchText})
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/globals/SearchBar.vue